import _VideoLibrary from "@mui/icons-material/VideoLibrary";
import _PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import _PhotoLibrary from "@mui/icons-material/PhotoLibrary";
import _LibraryBooks from "@mui/icons-material/LibraryBooks";
import _LibraryMusic from "@mui/icons-material/LibraryMusic";
import _ChildCare from "@mui/icons-material/ChildCare";
import everyoneIcon from '../assets/images/ride-difficulties/everyone.svg';
import familyIcon from '../assets/images/ride-difficulties/family.svg';
import sportiveIcon from '../assets/images/ride-difficulties/sportive.svg';
import coastalImage from '../assets/images/ride-themes/coastal.png';
import culturalImage from '../assets/images/ride-themes/cultural.png';
import familyImage from '../assets/images/ride-themes/family.png';
import gourmetImage from '../assets/images/ride-themes/gourmet.png';
import mountainImage from '../assets/images/ride-themes/mountain.png';
import natureImage from '../assets/images/ride-themes/nature.png';
import sportiveImage from '../assets/images/ride-themes/sportive.png';
import urbanImage from '../assets/images/ride-themes/urban.png';
import { EasyIcon, HardIcon, MediumIcon, WebsiteIcon } from '../components/icons';
import { toBounds } from '../utils';
export class Ride {
  constructor(id, creator, title, description, distance, duration, overloadDuration, verticalGain, difficulty, publicKind, area, themeIds, iconUrl, from, to, center, condensedGeometry, condensedReturnGeometry, routeId, returnRouteId, isLoop, isHighlighted, steps, poiIds, photos, medias, publicationStatus, partners, traceIds, belongingBikeRoutes, previousRideId, nextRideId, updated, created, privacy, bikeType, profile, metaTitle, metaDescription, viewsCount) {
    this.id = id;
    this.creator = creator;
    this.title = title;
    this.description = description;
    this.distance = distance;
    this.duration = duration;
    this.overloadDuration = overloadDuration;
    this.verticalGain = verticalGain;
    this.difficulty = difficulty;
    this.publicKind = publicKind;
    this.area = area;
    this.themeIds = themeIds;
    this.iconUrl = iconUrl;
    this.from = from;
    this.to = to;
    this.center = center;
    this.condensedGeometry = condensedGeometry;
    this.condensedReturnGeometry = condensedReturnGeometry;
    this.routeId = routeId;
    this.returnRouteId = returnRouteId;
    this.isLoop = isLoop;
    this.isHighlighted = isHighlighted;
    this.steps = steps;
    this.poiIds = poiIds;
    this.photos = photos;
    this.medias = medias;
    this.publicationStatus = publicationStatus;
    this.partners = partners;
    this.traceIds = traceIds;
    this.belongingBikeRoutes = belongingBikeRoutes;
    this.previousRideId = previousRideId;
    this.nextRideId = nextRideId;
    this.updated = updated;
    this.created = created;
    this.privacy = privacy;
    this.bikeType = bikeType;
    this.profile = profile;
    this.metaTitle = metaTitle;
    this.metaDescription = metaDescription;
    this.viewsCount = viewsCount;
    this.bounds = condensedGeometry ? toBounds(condensedGeometry) : undefined;
    this.boundsCenter = this.bounds ? {
      type: 'Point',
      coordinates: [(this.bounds.east + this.bounds.west) / 2, (this.bounds.north + this.bounds.south) / 2]
    } : undefined;
  }
  clone() {
    return new Ride(this.id, this.creator, this.title, this.description, this.distance, this.duration, this.overloadDuration, this.verticalGain, this.difficulty, this.publicKind, this.area, this.themeIds, this.iconUrl, this.from, this.to, this.center, this.condensedGeometry, this.condensedReturnGeometry, this.routeId, this.returnRouteId, this.isLoop, this.isHighlighted, this.steps, this.poiIds, this.photos, this.medias, this.publicationStatus, this.partners, this.traceIds, this.belongingBikeRoutes, this.previousRideId, this.nextRideId, this.updated, this.created, this.privacy, this.bikeType, this.profile, this.metaTitle, this.metaDescription, this.viewsCount);
  }
}
export const rideThemesMap = {
  nature: {
    labelKey: 'commons.ride.themes.nature',
    image: natureImage,
    hasDescription: true
  },
  cultural: {
    labelKey: 'commons.ride.themes.cultural',
    image: culturalImage,
    hasDescription: true
  },
  sportive: {
    labelKey: 'commons.ride.themes.sportive',
    image: sportiveImage,
    hasDescription: true
  },
  urban: {
    labelKey: 'commons.ride.themes.urban',
    image: urbanImage
  },
  mountain: {
    labelKey: 'commons.ride.themes.mountain',
    image: mountainImage
  },
  coastal: {
    labelKey: 'commons.ride.themes.coastal',
    image: coastalImage
  },
  family: {
    labelKey: 'commons.ride.themes.family',
    image: familyImage,
    hasDescription: true
  },
  gourmet: {
    labelKey: 'commons.ride.themes.gourmet',
    image: gourmetImage
  }
};
export const publicKindsMap = {
  everyone: {
    labelKey: 'commons.ride.public_kinds.everyone'
  },
  family: {
    labelKey: 'commons.ride.public_kinds.family',
    Icon: _ChildCare
  },
  sportive: {
    labelKey: 'commons.ride.public_kinds.sportive'
  }
};
export const difficultiesMap = {
  easy: {
    labelKey: 'commons.ride.difficulties.easy',
    Icon: EasyIcon,
    icon: everyoneIcon,
    color: '#E7F4FA'
  },
  medium: {
    labelKey: 'commons.ride.difficulties.medium',
    Icon: MediumIcon,
    icon: familyIcon,
    color: '#DAF3DF'
  },
  hard: {
    labelKey: 'commons.ride.difficulties.hard',
    Icon: HardIcon,
    icon: sportiveIcon,
    color: '#EAE2FC'
  }
};
export const mediaTypesMap = [{
  key: 'audio',
  labelKey: 'commons.ride.media_types.audio',
  Icon: _LibraryMusic
}, {
  key: 'file',
  labelKey: 'commons.ride.media_types.file',
  Icon: _LibraryBooks
}, {
  key: 'image',
  labelKey: 'commons.ride.media_types.image',
  Icon: _PhotoLibrary
}, {
  key: 'pdf',
  labelKey: 'commons.ride.media_types.pdf',
  Icon: _PictureAsPdf
}, {
  key: 'video',
  labelKey: 'commons.ride.media_types.video',
  Icon: _VideoLibrary
}, {
  key: 'website',
  labelKey: 'commons.ride.media_types.website',
  Icon: WebsiteIcon
}];
export class RideTheme {
  constructor(id, key) {
    this.id = id;
    this.key = key;
  }
}